function _classPrivateMethodInitSpec(e, a) { _checkPrivateRedeclaration(e, a), a.add(e); }
function _classPrivateFieldInitSpec(e, t, a) { _checkPrivateRedeclaration(e, t), t.set(e, a); }
function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
function _classPrivateFieldGet(s, a) { return s.get(_assertClassBrand(s, a)); }
function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
import { createEditorPlatformManifestServicesError, EditorPlatformManifestServicesErrorCode } from './errors';
const MANIFEST_BUILDER_SCRIPT = 'blocks-builder-manifest-generator';
const DATA_FIXER_SCRIPT = 'santa-data-fixer';
const MANIFEST_VERSION_TOKEN = '$MANIFEST_MODULE_VERSION$';
const DATA_FIXER_TOKEN = '$DATA_FIXER_VERSION$';
var _manifestsUrls = /*#__PURE__*/new WeakMap();
var _ManifestUrlResolver_brand = /*#__PURE__*/new WeakSet();
export class ManifestUrlResolver {
  constructor(dm) {
    this.dm = dm;
    _classPrivateMethodInitSpec(this, _ManifestUrlResolver_brand);
    _classPrivateFieldInitSpec(this, _manifestsUrls, new Map());
  }
  getManifestUrlByCompType(compType) {
    const componentData = this.dm.builder.components.getCompAppData(compType);
    if (!componentData) {
      return undefined;
    }
    const {
      componentId,
      appDefinitionId
    } = componentData;
    const appData = this.dm.platform.getAppDataByAppDefId(appDefinitionId);
    const manifestUrl = _assertClassBrand(_ManifestUrlResolver_brand, this, _getManifestUrl).call(this, componentId, appData);
    if (!manifestUrl) {
      throw createEditorPlatformManifestServicesError(EditorPlatformManifestServicesErrorCode.ManifestUrlNotProvided).withComponentType(compType);
    }
    if (_classPrivateFieldGet(_manifestsUrls, this).has(compType)) {
      return _classPrivateFieldGet(_manifestsUrls, this).get(compType);
    }
    _classPrivateFieldGet(_manifestsUrls, this).set(compType, manifestUrl);
    return manifestUrl;
  }
}
function _getManifestUrl(componentId, appData) {
  var _appData$appFields;
  const key = `${componentId}_manifestUrl`;
  const baseManifestUrl = appData == null || (_appData$appFields = appData.appFields) == null || (_appData$appFields = _appData$appFields.platform) == null || (_appData$appFields = _appData$appFields.baseUrls) == null ? void 0 : _appData$appFields[key];
  if (!baseManifestUrl) {
    return null;
  }
  return _assertClassBrand(_ManifestUrlResolver_brand, this, _resolveManifestUrlTokens).call(this, baseManifestUrl);
}
function _resolveManifestUrlTokens(url) {
  const manifestGeneratorModuleVersion = this.dm.generalInfo.getSiteAssetsScriptVersion(MANIFEST_BUILDER_SCRIPT);
  const dfVersion = this.dm.generalInfo.getSiteAssetsScriptVersion(DATA_FIXER_SCRIPT);
  return url.replace(MANIFEST_VERSION_TOKEN, manifestGeneratorModuleVersion).replace(DATA_FIXER_TOKEN, dfVersion);
}
//# sourceMappingURL=ManifestUrlResolver.js.map